import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../../utils/withIntl";
import { Typography } from "@material-ui/core";
import articlesStore from "../../../store/articles/ArticlesStore";
import EditSwitch from "../../EditArticle/EditSwitch";
import EditCheckbox from "../../EditArticle/EditCheckbox";
import { createMuiTheme, makeStyles, ThemeProvider } from "@material-ui/core/styles";
import GetCurrency from "../../../helper/GetCurrency";
import EditSelect from "../../EditArticle/EditSelect";
import { Link } from "react-router-dom";
import cloudStore from "../../../store/CloudStore";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { useDialog } from "../../Dialogs/DialogProvider";
import NewModifiergroupDialog from "../Modifiergroups/NewModifiergroupDialog";

const useStyles = makeStyles((theme) => ({
  modifiergroupHeader: {
    display: "flex",
    alignItems: "center",
  },
  modifiergroupContainer: {
    marginLeft: 30,
  },
  modifierarticleContent: {
    display: "flex",
    alignItems: "center",
  },
  rootButton: { margin: 10 },
}));

function Modifiergroups(props) {
  const classes = useStyles();
  const [openDialog, closeDialog] = useDialog();
  const modifiergroups = props.article.getModifiergroups(articlesStore.modifiergroups);
  const theme = createMuiTheme({
    typography: {
      fontSize: 12,
    },
  });

  const handleOpenNewModifiergroupDialog = (event) => {
    event.stopPropagation();

    openDialog({
      children: <NewModifiergroupDialog article={props.article} fullWidth={true} />,
      fullWidth: true,
      maxWidth: "sm",
      disableBackdropClick: true,
    });
  };

  return (
    <div>
      <div>
        <Typography>{props.intl.formatMessage({ id: "option_articles" })}</Typography>
        <EditSelect
          disabled={props.disabled != null ? props.disabled : false}
          authorizationField={"modifiergroup.name"}
          value={props.article.modifiergroupIds}
          optionValues={Object.keys(articlesStore.modifiergroups).map((key) => parseInt(key))}
          optionViewValues={Object.keys(articlesStore.modifiergroups).map(
            (id) => articlesStore.modifiergroups[id].name
          )}
          multiple={true}
          onChange={(value, setBeginValue) => {
            props.onChange(value, setBeginValue);
          }}
        />
        <Button
          variant={"outlined"}
          color={"primary"}
          classes={{ root: classes.rootButton }}
          onClick={handleOpenNewModifiergroupDialog}
          endIcon={<AddIcon color={"primary"} />}
        >
          {props.intl.formatMessage({ id: "create_new_option_group" })}
        </Button>
      </div>
      <ThemeProvider theme={theme}>
        {modifiergroups.map((modifiergroup) => {
          return (
            <div key={modifiergroup.id}>
              <div className={classes.modifiergroupHeader}>
                <EditSwitch
                  value={modifiergroup.manual_active}
                  authorizationField={"modifiergroup.manual_active"}
                  disabled={true}
                />
                <Button
                  variant={"outlined"}
                  color={"primary"}
                  component={Link}
                  onClick={closeDialog}
                  to={`/home/${cloudStore.merchant.id}/articles/options?searchValue=${
                    articlesStore.modifiergroups[modifiergroup.id].name
                  }&modifiergroupId=${modifiergroup.id}`}
                >
                  {modifiergroup.name}
                </Button>
                <EditCheckbox
                  authorizationField={"modifiergroup.optional"}
                  value={modifiergroup.optional}
                  label={"Optional"}
                  disabled={true}
                />
                <EditCheckbox
                  authorizationField={"modifiergroup.multiple"}
                  value={modifiergroup.multiple}
                  label={"Multiple"}
                  disabled={true}
                />
                <EditCheckbox
                  authorizationField={"modifiergroup.numerable"}
                  value={modifiergroup.numerable}
                  label={"Telbaar"}
                  disabled={true}
                />
              </div>
              <div className={classes.modifiergroupContainer}>
                {modifiergroup.getModifierarticles(articlesStore.modifierarticles).map((modifierarticle) => {
                  return (
                    <div key={modifierarticle.id} className={classes.modifierarticleContent}>
                      <EditSwitch
                        value={modifierarticle.manual_active}
                        authorizationField={"modifierarticle.manual_active"}
                        disabled={true}
                      />
                      <Typography style={{ margin: "0 8px" }}>{modifierarticle.name}</Typography>
                      <Typography>{GetCurrency() + " " + (modifierarticle.price / 100).toFixed(2)}</Typography>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </ThemeProvider>
    </div>
  );
}

Modifiergroups.propTypes = {
  article: PropTypes.object.isRequired,
};

export default withIntl(Modifiergroups);
